module.exports = __webpack_public_path__ + "static/media/right-arrow.1ef03e69.svg";